/**
 * @module app.cd
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import * as CD from 'app/cd/models/essette-api';

@autoinject
export class DrugDisplay {

    ////****************** Fields and Properties ************************************////
    @bindable.objectNull({ defaultBindingMode: bindingMode.toView })
    public drug: CD.Drug | null = null;
    @bindable.boolean({ defaultBindingMode: bindingMode.oneTime })
    public showCode: boolean = false;
    @bindable.boolean({ defaultBindingMode: bindingMode.oneTime })
    public showTooltip: boolean = false;

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////


    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////

}
